import { useState } from "react";

type FaqItem = {
  q: string;
  a: string;
};

const FaqAccordion = ({ items }: { items: FaqItem[] }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-foreground-950/10 border-y border-foreground-950/10">
      {items.map((item, index) => {
        const open = openIndex === index;
        return (
          <div key={item.q}>
            <button
              type="button"
              onClick={() => setOpenIndex(open ? null : index)}
              aria-expanded={open}
              className="flex w-full cursor-pointer items-start justify-between gap-4 py-5 text-left"
            >
              <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                {item.q}
              </span>
              <span
                className={`mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                  open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                }`}
              >
                <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-base`}></i>
              </span>
            </button>
            <div
              className={`grid transition-all duration-300 ${
                open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
              }`}
            >
              <div className="overflow-hidden">
                <p className="pb-5 pr-10 text-sm leading-relaxed text-foreground-600">{item.a}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FaqAccordion;